module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "editable": false,
      "deletable": false,
      "bulk": false,
      "paginating": !_vm.small,
      "exportable": !_vm.small,
      "filtering": !_vm.small,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(_vm.$t(_vm.textValues[row.item.type], JSON.parse(row.item.text))) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75d61f76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Notifications.vue
// module id = 1087
// module chunks = 1